import { defineMessages } from 'react-intl'

export const networkStatusMessages = defineMessages({
  noSubs: {
    id: 'networkStatusMessages.noSubs',
    description: 'Button text when no active subscriptions',
    defaultMessage: 'Subscribe',
  },
  hasSubs: {
    id: 'networkStatusMessages.hasSubs',
    description: 'Button text when active subscriptions',
    defaultMessage: 'Manage',
  },
  subRenewalTitle: {
    id: 'networkStatusMessages.subRenewalTitle',
    description: 'Renew text when active subscriptions',
    defaultMessage: 'Renewal Date',
  },
  subExpireTitle: {
    id: 'networkStatusMessages.subExpireTitle',
    description: 'Expire text when csnceled subscriptions',
    defaultMessage: 'Expiration Date',
  },
  subTotalTitle: {
    id: 'networkStatusMessages.subTotalTitle',
    description: 'Title text for subscriptions Total',
    defaultMessage: 'Total',
  },
  subSubscribedText: {
    id: 'networkStatusMessages.subSubscribedText',
    description: 'Text for subscribed Total',
    defaultMessage: 'Subscribed',
  },
  subClaimedText: {
    id: 'networkStatusMessages.subClaimedText',
    description: 'Text for claimed Total',
    defaultMessage: 'Claimed',
  },
})
